import { render } from "./ProductInfoTablist.vue?vue&type=template&id=734f14ab"
import script from "./ProductInfoTablist.vue?vue&type=script&lang=js"
export * from "./ProductInfoTablist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__